import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveJobsite = async (jobsite, navigate) => {
  const accessToken = getToken();

  if (!accessToken) {
    console.warn("Access token is not available.");
    return {
      success: false,
      error: "Access token is missing. Please log in.",
    };
  }

  const payload = {
    jobsiteID: jobsite.jobsiteID || 0,
    customerID: jobsite.customerID || 0,
    jobsiteType: jobsite.jobsiteType,
    jobsiteName: jobsite.jobsiteName,
    street1: jobsite.street1,
    street2: jobsite.street2,
    floorLevel: jobsite.floorLevel,
    unitNumber: jobsite.unitNumber,
    city: jobsite.city,
    state: jobsite.state,
    zipCode: jobsite.zipCode,
    county: jobsite.county,
    billingAddress: jobsite.billingAddress,
    contact: jobsite.contact,
  };

  try {
    const response = await fetch(`${dev_baseUrl}/Jobsite/saveJobsite`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (response.ok) {
      if (data.isError) {
        console.error("Server returned an error:", data);
        return {
          success: false,
          error: data.message || "An unknown error occurred.",
        };
      }

      return {
        success: true,
        data: data.result,
      };
    }

    if (data.statusCode === "Unauthorized") {
      console.warn("Unauthorized access. Redirecting to login.");
      navigate("/login");
      return {
        success: false,
        error: "Unauthorized access. Please log in again.",
      };
    }

    console.error("Server error:", data);
    return {
      success: false,
      error: data.message || "An error occurred on the server.",
    };
  } catch (error) {
    console.error("Network error:", error);
    return {
      success: false,
      error: "A network error occurred. Please try again later.",
    };
  }
};
